export const Contexts = {
  AT: 'at',
  DEV: 'dev',
  LOCAL: 'local',
  PROD: 'prod',
};

export default () => {
  // see https://docs.google.com/spreadsheets/d/1YuOj5tdDo3d4KwU_k6040AEr3fKnEIYfIfsRzPrq9Hc for local
  // vhost urls.
  //
  const hostName = document.location.hostname;
  let result;

  // local urls will have the word local in them so `localhost` and `local` will both match 'local'
  if (hostName.includes('local')) {
    result = Contexts.LOCAL;
  } else if (hostName.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/)) {
    result = Contexts.DEV;
  } else if (hostName.includes('.dev.') || hostName.includes('ut-uid-pharma-dev')) {
    result = Contexts.DEV;
  } else if (hostName.includes('.at.') || hostName.includes('ut-uid-pharma-at')) {
    // The Firebase default-domain hosting sites (ut-uid-pharma-at.web.app and the
    // parallel ut-uid-pharma-at-v2.web.app) do NOT contain '.at.', so also match
    // the AT project id — otherwise they fall through to the PROD default and the
    // app calls the prod Cloud Functions / loads the prod Firebase config.
    result = Contexts.AT;
  } else if (hostName.includes('ut-uid-pharma-prod')) {
    result = Contexts.PROD;
  } else {
    // default to prod if find no other match
    result = Contexts.PROD;
  }

  return result;
};
